import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CmsNavigationComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UigNavigationService } from 'src/app/services/uig-navigation.service';
import { UigNavigationNode } from '../uig-navigation/uig-navigation-node-model';

@Component({
    selector: 'app-uig-footer',
    templateUrl: './uig-footer.component.html',
    styleUrls: ['./uig-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigFooterComponent implements OnInit {

  node$: Observable<UigNavigationNode> = this.service.getNavigationNode(
    this.componentData.data$
  );
    
  styleClass$: Observable<string> = this.componentData.data$.pipe(
    map((d) => d?.styleClasses)
  );

  constructor(
    protected componentData: CmsComponentData<CmsNavigationComponent>,
    protected service: UigNavigationService) { }

  ngOnInit(): void {

  }

}
